var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.234 13.228c-.778 0-1.48.337-1.983.877l-5.737-2.803a3.166 3.166 0 0 0 0-.604l5.737-2.803c.503.54 1.205.878 1.984.878C17.76 8.773 19 7.48 19 5.886 19 4.292 17.762 3 16.235 3c-1.527 0-2.765 1.292-2.765 2.886 0 .103.005.203.015.303L7.747 8.991a2.7 2.7 0 0 0-1.983-.877C4.238 8.114 3 9.406 3 11s1.238 2.886 2.765 2.886c.778 0 1.48-.337 1.983-.877l5.737 2.802c-.009.1-.015.2-.015.303 0 1.594 1.237 2.886 2.765 2.886C17.762 19 19 17.708 19 16.114s-1.239-2.886-2.766-2.886Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.6dbe397f41ac109a9148f7086fe361b9.svg";